<template>
  <v-card elevation="2" class="mb-4">
    <v-card-title class="text-subtitle-1 font-weight-bold">
      <v-icon v-if="icone" small left color="primary">{{ icone }}</v-icon>
      {{ titulo }}
    </v-card-title>
    <v-card-subtitle v-if="subtitulo">{{ subtitulo }}</v-card-subtitle>
    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
/** Um bloco de formulário em card. */
export default {
  name: "ESecaoFormulario",
  props: {
    titulo: { type: String, required: true },
    icone: { type: String, default: null },
    subtitulo: { type: String, default: null },
  },
};
</script>
